import { render, staticRenderFns } from "./RewardCase.vue?vue&type=template&id=5766311f&scoped=true"
import script from "./RewardCase.vue?vue&type=script&lang=js"
export * from "./RewardCase.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/mkt-cms.css?vue&type=style&index=0&id=5766311f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5766311f",
  null
  
)

export default component.exports